<template>
  <div class="home">
    <LandingCards/>
  </div>
</template>

<script>

import LandingCards from "@/components/LandingCards.vue";

export default {
  name: "Home",
  components: {
    LandingCards
  },
  mounted() {
    localStorage.removeItem('userName');
    localStorage.removeItem('userType');
    window.dispatchEvent(new CustomEvent('setUsername', {
      detail: {
          username: localStorage.getItem('userName')
      }
    }));
  }
};
</script>

<style scoped>
  div {
    width: 100%;
  }
</style>
